import { Drawer } from '@mui/material';
import useAppMethods from '../../hooks/utility/useAppMethods';
import CustomNavBar from '../../components-library/navigation/CustomNavBar';
import { FC } from 'react';
import OrderBasket from '../../components-library/order-basket';
import useTheme from '../../hooks/ui/useTheme';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
}

const OrderBasketModal: FC<Props> = ({ open }) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modals:OrderBasket:OrderBasket' });
  const { toggleOrderBasketModal } = useAppMethods();
  const theme = useTheme();

  const closeModal = () => toggleOrderBasketModal({ openModal: false });
  const backdrop = theme.isDarkMode
    ? {
        backgroundColor: 'rgba(52, 52, 52, 0.1)',
      }
    : {
        backgroundColor: 'rgba(52, 52, 52, 0)',
      };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeModal}
      slotProps={{
        paper: {
          sx: {
            borderTopLeftRadius: { sm: '16px' },
            borderBottomLeftRadius: { sm: '16px' },
            width: { xs: '100vw', sm: '525px' },
          },
        },
        backdrop: {
          sx: backdrop,
        },
      }}
      ModalProps={{
        disableEnforceFocus: true,
      }}
    >
      <CustomNavBar
        title={<h6 className="text-sm top-1/2 -translate-y-1/2 absolute left-md">{t('title')}</h6>}
        rightClick={closeModal}
        hideBackIcon
        containerClassName="relative !py-sm bg-brand-background-primary"
      />
      <OrderBasket className="bg-brand-background-primary" />
    </Drawer>
  );
};

export default OrderBasketModal;
